import { NgModule } from '@angular/core';
/**
 * Pipes(s)
 */
import { rtiSafeHtmlPipe } from './common/rti-safe-html.pipe';

const TP_PIPE = [
  rtiSafeHtmlPipe
];

@NgModule({
  imports: [],
  declarations: TP_PIPE,
  exports: TP_PIPE
})
/**
 *   Module:  RtiPipeModule
 *   Description:  The module 'RtiPipeModule' is designed to ...
 *   Author: Lovelidge, Shawn
 */
export class RtiPipeModule {
  constructor() {
  }
}
